import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9a7m2r54fa: FaireBrandEntity = {
  token: "b_9a7m2r54fa",
  type: "brand",
  name: "Gioiellin - S925 Silver Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/2c04ca4f56f35ab1378618082e13bad12522bd9559e0e3cd634ff52f6cfc1138.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1bf2878e5090571d2e289f715133206afc9b54767016d629dbf2f59ceace4874.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2c04ca4f56f35ab1378618082e13bad12522bd9559e0e3cd634ff52f6cfc1138.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1bf2878e5090571d2e289f715133206afc9b54767016d629dbf2f59ceace4874.jpeg",
  location: "HKG",
  minimumOrderDollars: 69,
  rating: 4.6,
  reviewCount: 9,
  isInsider: true,
  description:
    "Welcome to Gioiiellin, where exceptional craftsmanship meets timeless elegance. We specialize in the exclusive use of S925 silver, ensuring a standard of excellence that sets us apart. Beyond the value of jewelry, Gioiiellin is a conduit for dreams and emotions, providing a way to express love and preserve cherished memories. Gioiiellin stands as a testament to our unwavering commitment to excellence, where every piece is not just an accessory but a narrative waiting to be told.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:09.833Z",
    importedBy: "entity-db-cli",
  },
};
